"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/styles");
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    helpIcon: {
      margin: theme.spacing(0, 0.5),
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.NEUTRAL100,
      verticalAlign: 'bottom'
    }
  };
});
var _default = useStyles;
exports.default = _default;